import _ from 'lodash'

export default class Helper{

    constructor(){

    }

    updateSentenceColor(sentences, categories){
        _.forEach(sentences, function(sen) {
            _.forEach(categories, function(cat) {
                let index = _.findIndex(sen.categories, function(c) { return c.id == cat.id; });
                if( index !== -1){
                    sen.categories[index].pivot = cat.pivot;
                }
            });
        });
        return sentences;
    }

    parseSentence(sentence, wasJoiner = false, gender){
        let self = this;
        let filtered = sentence.text;

        if(wasJoiner){
            filtered = filtered.charAt(0).toLowerCase() + filtered.slice(1);
        }
        //todo optimize this
        if(gender == "female"){
            filtered = filtered.replace(new RegExp("\\bhe\\b","g"), 'she')
                .replace(new RegExp("\\bHe\\b","g"), 'She')
                .replace(new RegExp("\\bhis\\b","g"), 'her')
                .replace(new RegExp("\\bHis\\b","g"), 'Her')
                .replace(new RegExp("\\bhimself\\b","g"), 'herself')
                .replace(new RegExp("\\bHimself\\b","g"), 'Herself')
                .replace(new RegExp("\\bhim\\b","g"), 'her')
                .replace(new RegExp("\\bHim\\b","g"), 'Her');
        }
        else{
            filtered = filtered.replace(new RegExp("\\bshe\\b","g"), 'he')
                .replace(new RegExp("\\bShe\\b","g"), 'He')
                .replace(new RegExp("\\blike her\\b","g"), 'like him')
                .replace(new RegExp("\\bLike her\\b","g"), 'Like him')
                .replace(new RegExp("\\blove her\\b","g"), 'love him')
                .replace(new RegExp("\\bLove her\\b","g"), 'Love him')
                .replace(new RegExp("\\bsupport her\\b","g"), 'support him')
                .replace(new RegExp("\\bSupport her\\b","g"), 'Support him')
                .replace(new RegExp("\\to her\\b","g"), 'to him')
                .replace(new RegExp("\\bTo her\\b","g"), 'To him')
                .replace(new RegExp("\\bof her\\b","g"), 'of him')
                .replace(new RegExp("\\bOf her\\b","g"), 'Of him')
                .replace(new RegExp("\\bin her\\b","g"), 'in him')
                .replace(new RegExp("\\bIn her\\b","g"), 'In him')
                .replace(new RegExp("\\bher\\b","g"), 'his')
                .replace(new RegExp("\\bHer\\b","g"), 'His')
                .replace(new RegExp("\\bherself\\b","g"), 'himself')
                .replace(new RegExp("\\bHerself\\b","g"), 'Himself');
        }

        filtered = filtered.replace(new RegExp("\\bi\\b","g"), 'I');
        filtered = filtered.replace(new RegExp("\\bchina\\b","g"), 'China');
        filtered = filtered.replace(new RegExp("\\busa\\b","g"), 'Usa');
        filtered = filtered.replace(new RegExp("\\buSA\\b","g"), 'USA');

        return filtered;
    }

    prepareSentencesForServer(choosedSentences){
        let sentences = [];
        var i = 0;
        _.forEach(choosedSentences, function(value) {

            if(!value.isJoiner){
                sentences.push({
                    id: value.id,
                    order: i,
                    joiner: ""
                });
                i++;
            }
            else{
                if(i > 0){
                    sentences[i-1].joiner = value.text;
                }
            }
        });

        return sentences;
    }

    prepareOriginalTextForServer(text, student, lesson, teacher){
        if(student && student.name && student.name != ''){
            //text = text.replace(new RegExp("\\buSA\\b","g"), 'USA');
            text = _.replace(text, new RegExp("\\b"+student.name+"\\b","gi"),"{{student.name}}")
        }
        if(lesson && lesson.name && lesson.name != '' && lesson.words && lesson.words != ''){
            text = _.replace(text,new RegExp("\\b"+lesson.name+"\\b","gi"),"{{lesson.name}}")
            text = _.replace(text,new RegExp("\\b"+lesson.words+"\\b","gi"),"{{lesson.words}}")
        }
        if(teacher && teacher.name && teacher.name != '' && teacher.nick && teacher.nick != ''){
            text = _.replace(text,new RegExp("\\b"+teacher.name+"\\b","gi"),"{{teacher.name}}")
            text = _.replace(text,new RegExp("\\b"+teacher.nick+"\\b","gi"),"{{teacher.nick}}")
        }
        return text;
    }

}


// WEBPACK FOOTER //
// ./src/services/Helper.js